import React, { Component } from 'react';
import FormExplanationValidation from './FormExplanationValidation';
import { isEmpty } from '../Utilities/JsonFunctions';
declare var $;

class NamezzzTelNum extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    handleChange(e) {
        var telCountry = this.getTelNr(this.props.value, 0);
        var telZone = this.getTelNr(this.props.value, 1);
        var telAbon = this.getTelNr(this.props.value, 2);

        var names = e.target.id.split("_");
        var name = names[names.length - 1];

        switch(name) {
            case "country" : telCountry = e.target.value.replace("+", "00").replace(/\D/g,''); break;
            case "zone" : telZone = e.target.value.replace(/\D/g,''); break;
            case "abon" : telAbon = e.target.value.replace(/\D/g,''); break;
            default: return;
        }

        var value = telCountry + "#" + telZone + "#" + telAbon;

        var eNew = {
            target: {
                id: this.props.id,
                value: value
            }
        }

        this.props.onChange(eNew);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    getTelNr(nr, index) {
        if (isEmpty(nr)) {
            return "";
        }

        var nrs = nr.split("#");
        if (nrs.length !== 3) {
            return "";
        }

        nrs[index] = nrs[index].replace("+", "00").replace(/\D/g,'');

        return nrs[index];
    }

    render() {
        let requiredMark = this.props.required && !this.props.readonly ? <span className="required-mark">*</span> : null;

        let telNumText = isEmpty(this.getTelNr(this.props.value, 0)) && 
                         isEmpty(this.getTelNr(this.props.value, 1)) && 
                         isEmpty(this.getTelNr(this.props.value, 2)) ? "" :
                            "(" + this.getTelNr(this.props.value, 0) + ") " + this.getTelNr(this.props.value, 1) + "/" + this.getTelNr(this.props.value, 2);

        return (
            <div className="tr">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.readonly ? null : this.props.id + "_country"}>{this.props.text}
                        {requiredMark}
                    </label>
                </div>
                {
                    (this.props.readonly) ?
                        <div className="EditingFormValueCell td"><p className="form-control-static">{telNumText}</p></div> : 
                        <div className="EditingFormValueCell td">
                            <div className="form-group row">
                                <div className="col-xs-4 telcountry">
                                    <input type="text" id={this.props.id + "_country"} maxLength="5" className="form-control" autoComplete={this.props.autocomplete ? "tel-country-code" : "no-autocomplete"}
                                        onChange={this.handleChange} onKeyPress={this.onKeyPress} value={this.getTelNr(this.props.value, 0)} />
                                </div>
                                
                                <div className="col-xs-4 telzone">
                                    <input type="text" id={this.props.id + "_zone"} maxLength="6" className="form-control" autoComplete={this.props.autocomplete ? "tel-area-code" : "no-autocomplete"}
                                        onChange={this.handleChange} onKeyPress={this.onKeyPress} value={this.getTelNr(this.props.value, 1)} />
                                </div>
                            
                                <div className="col-xs-4 telabon">
                                    <input type="text" id={this.props.id + "_abon"} maxLength="15" className="form-control" autoComplete={this.props.autocomplete ? "tel-local" : "no-autocomplete"}
                                        onChange={this.handleChange} onKeyPress={this.onKeyPress} value={this.getTelNr(this.props.value, 2)} />
                                </div>
                            </div>
                            <FormExplanationValidation id={this.props.id + "_country"} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                        </div>
                }

            </div>
        );
    }
}

export default NamezzzTelNum;


// WEBPACK FOOTER //
// ./src/Fields/NamezzzTelNum.js